type Point = { x: number; y: number; z: number };
export type CreatureFollower = { id: string; expected_rev: number; before: Point; after: Point };
const record = (value: unknown): Record<string, unknown> | null =>
  value !== null && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : null;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The browser owns the position-only wire contract; PHP projects its fixed save columns. */
export function validCreatureFollowers(raw: unknown): raw is CreatureFollower[] {
  if (!Array.isArray(raw)) return false;
  const ids = new Set<string>();
  return raw.every(value => {
    const member = record(value);
    if (!member || Object.keys(member).some(key => !['id', 'expected_rev', 'before', 'after'].includes(key))
      || typeof member.id !== 'string' || !UUID.test(member.id)
      || typeof member.expected_rev !== 'number' || !Number.isInteger(member.expected_rev) || member.expected_rev < 0) return false;
    const id = member.id.toUpperCase();
    if (ids.has(id)) return false;
    ids.add(id);
    return ['before', 'after'].every(section => {
      const point = record(member[section]);
      return point !== null && Object.keys(point).length === 3 && ['x', 'y', 'z'].every(axis => {
        const coordinate = point[axis];
        return typeof coordinate === 'number' && Number.isFinite(coordinate) && Math.abs(coordinate) <= 999999;
      });
    });
  });
}
